export default __webpack_public_path__ + "static/8f117883-5a7a-40c2-a28f-d0478a469f2b-332d54c23dafad462bf4d98fc05929e4.woff2";